import React from 'react';

import placeholder from '../../assets/images/placeholder.jpeg';

import { Box, Typography, Grid, Button } from '@mui/material';

const openseaFilterURL =
  'https://opensea.io/collection/ens-equinox-collection?search[stringTraits][0][name]=series&search[stringTraits][0][values][0]=';

const openseFiltersBySeries = {
  'Summer Maiden': 'Summer%20Maiden',
};

const BP3 = '@media (max-width: 996px)';
const BP5 = '@media (max-width: 899px)';
const BP6 = '@media (max-width: 671px)';
const BP7 = '@media (max-width: 599px)';
const BP8 = '@media (max-width: 594px)';
const BP9 = '@media (max-width: 491px)';
const BP10 = '@media (max-width: 386px)';

const sx = {
  root: {
    width: '100%',
  },
  nftContainer: (canClick) => ({
    backgroundColor: '#fff',
    width: '100%',
    paddingTop: '137%',
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '10px',
    transition: 'all .3s',
    perspective: '1px',
    ...(canClick
      ? {
          cursor: 'pointer',
        }
      : {}),
  }),
  nftImg: {
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  text: {
    mt: '15px',
    fontFamily: 'amallia',
    mb: '10px',
    fontSize: '50px',
    color: '#3F4B0C',
    lineHeight: '75px',
    textAlign: 'center',
    [BP3]: {
      fontSize: '45px',
    },
    [BP5]: {
      fontSize: '50px',
    },
    [BP6]: {
      fontSize: '45px',
    },
    [BP7]: {
      fontSize: '50px',
    },
    [BP8]: {
      fontSize: '40px',
    },
    [BP9]: {
      fontSize: '30px',
    },
    [BP10]: {
      fontSize: '23px',
    },
  },
  id: {
    fontFamily: 'boucherie-block',
    fontSize: '22px',
    color: '#C58200',
    lineHeight: {
      xs: '22px',
      sm: '22px',
      md: '32px',
      lg: '66px',
    },
    textAlign: 'center',
  },
  btn: {
    mx: 'auto',
    my: 1,
    fontSize: '16px',
    width: '80px',
    fontFamily: 'boucherie-block',
    borderRadius: '0px',
    minHeight: '35px',
    border: '2px solid #020100',
    backgroundColor: '#020100',
    backgroundClip: 'content-box',
    padding: '5px',
    '&:hover': {
      border: '2px solid #9D4C10',
      backgroundColor: '#9D4C10',
    },
    '&:active': {
      border: '2px solid #6A330A',
      backgroundColor: '#6A330A',
    },
  },
  innerId: {
    fontFamily: 'boucherie-block',
    fontSize: '22px',
    color: '#C58200',
    textAlign: 'center',
  },
};
const zeroPad = (num, places) => String(num).padStart(places, '0');

const Card = ({
  setFullscreenSource,
  image,
  name,
  id,
  md,
  xs,
  sm = 6,
  titleFontSize,
  sxImageContainer,
  sxImage,
  onClick,
  innerId,
  sxRoot,
  renderExtra,
  isForge = false,
}) => {
  const handleOpensea = () => {
    window.open(openseaFilterURL + name.replace(/ /g, '%20'));
  };
  return (
    <Grid
      item
      xs={xs}
      sm={sm}
      md={md}
      sx={{
        ...sx.root,
        ...sxRoot,
      }}
    >
      <Box
        sx={{
          position: 'relative',
          flexDirection: 'column',
          height: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          minHeight: '100%',
        }}
      >
        <Box
          sx={{
            ...sx.nftContainer(setFullscreenSource != null || onClick != null),
            ...sxImageContainer,
          }}
          onClick={() => {
            if (setFullscreenSource) {
              setFullscreenSource(image || placeholder);
            }
            if (onClick) {
              onClick();
            }
          }}
        >
          <Box
            component="img"
            sx={{ ...sx.nftImg, ...sxImage }}
            src={image || placeholder}
          />

          {renderExtra}
        </Box>

        {name && (
          <>
            <Typography
              variant="text"
              sx={sx.text}
              style={{
                fontSize: titleFontSize,
                lineHeight: titleFontSize + 'px',
              }}
            >
              {name || ''}
            </Typography>
            {innerId ? (
              <Typography variant="text" sx={sx.innerId}>
                {`#${zeroPad(innerId, 2)}`}
              </Typography>
            ) : (
              <>
                {isForge && (
                  <Button
                    variant="outlined"
                    sx={sx.btn}
                    onClick={() => handleOpensea()}
                  >
                    Buy Now
                  </Button>
                )}
              </>
            )}
          </>
        )}
        <Typography variant="text" sx={sx.id}>
          {id && `#${zeroPad(id, 2)}`}
        </Typography>
      </Box>
    </Grid>
  );
};

export default Card;
